<!--  -->
<template>
  <div class="menu">
    <div class="menu-item" v-for="(item,i) in imgdata" :key="i" @click="check(i)">
      <img :src="item.src" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgdata: [
        {
          src: require("../assets/1.png")
        },
        {
          src: require("../assets/2.png")
        },
        {
          src: require("../assets/3.png")
        }
      ]
    };
  },

  components: {},

  computed: {},

  methods: {
    check(val) {
      switch (val) {
        case 0:
          // document.getElementById("iframe").contentWindow.MMAPI.objectTarget(4);
          document.getElementById("iframe").contentWindow.MMAPI.shoufeizhantc()
          break;
        case 1:
          document.getElementById("iframe").contentWindow.MMAPI.k8tc()
          document.getElementById("iframe").contentWindow.MMAPI.riskK8("tbK8");
          break;
        case 2:
          document.getElementById("iframe").contentWindow.MMAPI.fuwuqutc()
          // document.getElementById("iframe").contentWindow.MMAPI.objectTarget(3);
          break;

        default:
          break;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.menu {
  width: auto;
  height: auto;
  position: absolute;
  right: 19.5%;
  top: 90px;
  z-index: 1000;
  .menu-item {
    cursor: pointer;
    margin-bottom: 6px;
  }
}
</style>